import ForgotPasswordForm from '../../components/login/ForgotPasswordForm'
import FormLayout from '../../layouts/FormLayout'

const ForgotPasswordScreen = () => {
  return (
    <FormLayout
      bg="cabanaSand"
      extraButton={{ text: 'Create account', navigation: 'Signup' }}>
      <ForgotPasswordForm />
    </FormLayout>
  )
}

export default ForgotPasswordScreen
